import script from "./detailsTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsTemplate.vue?vue&type=script&setup=true&lang=js"

import "./detailsTemplate.vue?vue&type=style&index=0&id=2ace6ba6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ace6ba6"]])

export default __exports__